<template>
  <pre v-if="render.isScript">{{ getContent }}</pre>
  <Typography.Text v-else v-bind="getBindValue">{{ getContent }}</Typography.Text>
</template>

<script setup lang="ts">
  import { Typography } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import type { BaseType, CopyConfig } from 'ant-design-vue/es/typography/Base';
  import type { TextProps } from 'ant-design-vue/es/typography/Text';
  import { omit } from '@mts-fe/utils';
  import { IN_DEV } from '@mts/utils/env';
  import type { CellProps } from '../../types/table';

  /** @deprecated 请使用BaseParagraph组件 */
  defineOptions({
    name: 'RenderText',
    inheritAttrs: false,
  });

  IN_DEV && console.error('请在平台配置组件：长文本（溢出提示）');

  interface TextColumnRender extends Omit<TextProps, 'type' | 'copyable'> {
    isScript?: boolean;
    textType?: BaseType;
    textKey?: string;
    text?: string;
    copyable?: boolean | (CopyConfig & { textKey?: string });
  }
  const props = withDefaults(defineProps<CellProps & { render: TextColumnRender }>(), {});

  const getContent = computed(() => {
    if (props.render.content) {
      return props.render.content;
    }

    return props.render.textKey
      ? props.record[props.render.textKey]
      : props.render.text || props.record[props.column.dataIndex!.toString()!] || '-';
  });

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    let copyable = props.render.copyable;
    if (typeof copyable === 'object') {
      const { textKey, ...restCopyable } = copyable;
      if (textKey) {
        copyable = { ...restCopyable, text: props.record[textKey] };
      }
    }

    return {
      ...attrs,
      ...omit(props.render, ['textKey', 'textType']),
      type: props.render.textType,
      copyable,
    } as TextProps;
  });
</script>
